<template>
  <div class="admin admin-handbook">
    <form class="a-filter" action="">
      <div class="a-filter__header">
        <h2 v-t="'form.catalogs.title'"></h2>
      </div>
      <div class="a-filter__body ">
        <div class="a-filter__block ">
          <div class="a-filter__label">{{$t('form.catalogs.catalog-type.label')}}:</div>
          <dropdown-new class="select-filter"
                        :placeholder="$t('form.catalogs.catalog-type.placeholder')"
                        :options="options"
                        v-model="catalog">
          </dropdown-new>
        </div>
      </div>
    </form>
    <component :is="component"></component>
  </div>
</template>

<script>
  import _ from 'lodash'
  import DepartmentCatalog from './DepartmentsCatalog'
  import AccreditationDocumentsCatalog from './AccreditationDocumentsCatalog'
  import TenderDocumentsCatalog from './TenderDocumentsCatalog'
  import LotNumbersCatalog from './LotNumbersCatalog'
  import ExpertCriteriaCatalog from './ExpertCriteriaCatalog'
  import PriceCriteriaCatalog from './PriceCriteriaCatalog'
  import WeightedCriteriaInReduction from './weighted-criteria-in-reduction/Catalog'
  import FileExtensionsCatalog from './file-extensions/Catalog'
  import ContractorsCatalog from './contractors/ContractorsCatalog'
//  import CategoriesCatalog from './categories/CategoriesCatalog'
  import TemplatesCatalog from './templates/TemplatesCatalog'
  import NomenclatureCatalog from './nomenclature/NomenclatureCatalog'
  import AdditionalExpensesCatalog from './additional-expenses/Catalog'
  import PresentPriceCatalog from './present-price/Catalog'
  import AdditionalPresentPriceCatalog from './additional-present-price/Catalog'
  import Regulations from './regulations/Catalog'
  import BlackBoxCatalog from './black-box/BlackBoxCatalog'
  export default {
    components: {
      DepartmentCatalog,
      AccreditationDocumentsCatalog,
      TenderDocumentsCatalog,
      LotNumbersCatalog,
      ExpertCriteriaCatalog,
      PriceCriteriaCatalog,
      FileExtensionsCatalog,
      ContractorsCatalog,
//      CategoriesCatalog,
      TemplatesCatalog,
      NomenclatureCatalog,
      //AdditionalExpensesCatalog,
      PresentPriceCatalog,
      AdditionalPresentPriceCatalog,
      Regulations,
      BlackBoxCatalog,
      WeightedCriteriaInReduction
    },

    data: () => ({
      catalog: undefined,

      catalogs: [
        {
          id: 'departments',
          component: 'DepartmentCatalog',
          name: ''
        },
        { id: 'accreditations', component: 'AccreditationDocumentsCatalog' },
        { id: 'tenders', component: 'TenderDocumentsCatalog' },
        // { id: 'lot-numbers', component: 'LotNumbersCatalog' },
        { id: 'expert-criteria', component: 'ExpertCriteriaCatalog' },
        { id: 'price-criteria', component: 'PriceCriteriaCatalog' },
        { id: 'weighted-criteria', component: 'WeightedCriteriaInReduction'},
        { id: 'file-extensions', component: 'FileExtensionsCatalog' },
        { id: 'contractors', component: 'ContractorsCatalog' },
//      { id: 'categories', component: 'CategoriesCatalog' },
        { id: 'templates', component: 'TemplatesCatalog' },
        // { id: 'nomenclature', component: 'NomenclatureCatalog' },
        //{ id: 'additional-expenses', component: 'AdditionalExpensesCatalog' },
        { id: 'present-price', component: 'PresentPriceCatalog' },
        { id: 'additional-present-price', component: 'AdditionalPresentPriceCatalog' },
        { id: 'regulations', component: 'Regulations' },
        { id: 'black-box', component: 'BlackBoxCatalog' }
      ]
    }),

    computed: {
      component() {
        const elem = _.find(this.catalogs, { id: this.catalog });
        return _.get(elem, 'component');
      },

      options() {
        return this.catalogs.map(c => ({
          id: c.id,
          name: this.$t(`form.catalogs.catalog-type.${c.id}.label`)
        }))
      }
    },

    watch: {
      catalog(from, to) {
        this.$router.push({ name: this.$route.name, query: { catalog: this.catalog }});
      }
    },

    created() {
      this.catalog = this.$route.query['catalog'];

      const component = this.component;
      if (!component) {
          this.catalog = undefined;
          this.$router.push({ name: this.$route.name, query: undefined });
      }
    }
  }
</script>

<style scoped>

</style>
